import { useDispatch, useSelector } from 'react-redux'
import {
  selectCartSubtotal,
  selectCartTotal,
  selectIsBusiness,
  useCartServiceDispatch,
} from '../../reducers/cartReducer'
import { toast } from 'react-toastify'

import { Link, Route, Routes, useMatch, useNavigate } from 'react-router-dom'
import Cart from './Cart'
import CartSummary from './CartSummary'
import DeliveryMethod from './DeliveryMethod'
import Payment from './Payment'
import Comments from './Comments'
import CheckStatus from './CheckStatus'
import { useContext, useEffect } from 'react'
import AccountChoice from './Account'
import { ShoppingBasket } from '@styled-icons/remix-fill/ShoppingBasket'
import { PersonFill } from '@styled-icons/bootstrap/PersonFill'
import MobileContext from '../../contexts/mobileContext'
import { VanShuttle } from '@styled-icons/fa-solid/VanShuttle'
import { CommentDetail } from '@styled-icons/boxicons-solid/CommentDetail'
import { BankCard } from '@styled-icons/remix-fill/BankCard'

const icons = {
  cart: <ShoppingBasket className="icon-m m-l" />,
  account: <PersonFill className="icon-m  m-l" />,
  delivery: <VanShuttle className="icon-m  m-l" />,
  comments: <CommentDetail className="icon-m  m-l" />,
  payment: <BankCard className="icon-m  m-l" />,
}

const OrderProcess = ({ stages, stage, mobile }) => {
  const currentIndex = stages.length - stages.indexOf(stage) - 1
  const lang = useSelector((state) => state.lang[state.lang.selectedLang])
  return (
    <div className="process-row">
      {stages.reverse().map((s, i) => (
        <Link
          style={{ pointerEvents: currentIndex <= i ? 'unset' : 'none' }}
          to={s}
          key={s}
          className={`process-stage ${currentIndex <= i ? 'active' : ''}`}>
          {mobile ? icons[s] : lang[s]}
        </Link>
      ))}
    </div>
  )
}

const Order = () => {
  const [mobile, setIsMobile] = useContext(MobileContext)

  const match = useMatch('/order_process/:stage')
  const stage = match.params.stage
  const lang = useSelector((state) => state.lang[state.lang.selectedLang])
  const dispatch = useDispatch()
  const cart = useSelector((state) => state.cart)
  const isBusiness = useSelector(selectIsBusiness)
  const isLocalCart = useSelector((state) => state.cart.localCart)
  const email = useSelector((state) => state.cart.email)
  const navigate = useNavigate()
  const { placeOrder, invoice } = useCartServiceDispatch()
  const total = useSelector(selectCartTotal)

  useEffect(() => window.scrollTo(0, 0), [])

  const order = () => {
    if (
      checkDeliveryMethod() &&
      checkCartNotEmpty() &&
      checkBusinessComments() &&
      checkAccount()
    ) {
      dispatch(placeOrder())
      return true
    } else {
      return false
    }
  }

  const sendInvoice = async () => {
    if (
      checkDeliveryMethod() &&
      checkCartNotEmpty() &&
      checkBusinessComments() &&
      checkAccount()
    ) {
      if (cart.email) {
        navigate('/info/invoiced')
      }
      dispatch(invoice())
    }
  }

  const checkBusinessComments = () => {
    if (
      cart.businessComments &&
      (cart.businessComments.name ||
        cart.businessComments.address ||
        cart.businessComments.regNo) &&
      !isBusiness
    ) {
      toast.error(lang.toast_incomplete_business_comments)
      return false
    }
    return true
  }

  const checkDeliveryMethod = () => {
    console.log(total)
    if (!cart.deliveryMethod) {
      toast.error(lang.toast_select_delivery_method)
      return false
    } else if (
      cart.deliveryMethod === 'pickupPoint' &&
      (!cart.pickupPointData || !cart.pickupPointData.id)
    ) {
      toast.error(lang.toast_select_pickup_point)
      return false
    } else if (
      cart.deliveryMethod === 'pickupPoint' &&
      (!cart.pickupPointData.name ||
        !cart.pickupPointData.surname ||
        !cart.pickupPointData.phone ||
        cart.pickupPointData.phone?.length < 4)
    ) {
      toast.error(lang.toast_pickup_point_data)
      return false
    } else if (cart.deliveryMethod === 'courrier' && !cart.courrierAddress) {
      toast.error(lang.toast_select_address)
      return false
    } else if (total < 0) {
      toast.error(lang.sum_too_low)
      return false
    } else {
      return true
    }
  }
  const checkCartNotEmpty = () => {
    if (cart.content.length < 1) {
      toast.error(lang.empty_cart)
      return false
    } else {
      return true
    }
  }
  const checkAccount = () => {
    if (isLocalCart) {
      if (!email) {
        toast.error(lang.toast_email_missing)
        return false
      }
    }
    return true
  }
  const runChecksAndNavigate = () => {
    if (stage === 'cart') {
      if (checkCartNotEmpty()) {
        if (isLocalCart) {
          navigate('account')
        } else {
          navigate('delivery')
        }
      }
    } else if (stage === 'account') {
      if (checkAccount()) {
        navigate('delivery')
      }
    } else if (stage === 'delivery') {
      if (checkDeliveryMethod()) {
        navigate('comments')
      }
    } else if (stage === 'comments') {
      if (checkBusinessComments()) {
        navigate('payment')
      }
    }
  }

  const nextStage = () => {
    switch (stage) {
      case 'cart':
        if (isLocalCart) {
          return 'account'
        }
        return 'delivery'

      case 'delivery':
        return 'comments'
      case 'comments':
        return 'payment'
      default:
        return undefined
    }
  }
  return (
    <div>
      <OrderProcess
        stage={stage}
        stages={
          isLocalCart
            ? ['cart', 'account', 'delivery', 'comments', 'payment']
            : ['cart', 'delivery', 'comments', 'payment']
        }
        mobile={mobile}
      />
      <div className="row wrap-reverse m-t">
        <div style={{ flex: '100 1 300px' }}>
          <Routes>
            <Route
              path="cart"
              element={<Cart content={cart.content} />}
            />
            <Route
              path="account"
              element={
                <AccountChoice runChecksAndNavigate={runChecksAndNavigate} />
              }
            />
            <Route
              path="delivery"
              element={<DeliveryMethod />}
            />
            <Route
              path="payment"
              element={
                <Payment
                  order={order}
                  invoice={sendInvoice}
                />
              }
            />
            <Route
              path="comments"
              element={<Comments />}
            />
            <Route
              path="check_status"
              element={<CheckStatus />}
            />
          </Routes>
        </div>
        <div style={{ flex: '1 0 360px' }}>
          <CartSummary
            stage={stage}
            nextStage={nextStage()}
            runChecksAndNavigate={runChecksAndNavigate}
            checkDeliveryMethod={checkDeliveryMethod}
            checkCartEmpty={checkCartNotEmpty}
          />
        </div>
      </div>
    </div>
  )
}

export default Order
